import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function flattenFieldsWithoutIdCheck(fields: SchemaField[]): SchemaField[] {
  const flattened: SchemaField[] = []

  for (const field of fields) {
    if ((field.type === 'group' || field.type === 'section') && field.fields) {
      flattened.push(...flattenFieldsWithoutIdCheck(field.fields))
    } else if (field.type === 'tabs' && field.tabs) {
      for (const tab of field.tabs) {
        if (tab.fields) {
          flattened.push(...flattenFieldsWithoutIdCheck(tab.fields))
        }
      }
    } else {
      flattened.push(field)
    }
  }

  return flattened
}
